// // src/components/Navbar.js
// import React, { useState, useEffect } from "react";
// import logo from "../assets/logo_VBZ.png";
// import "../styles/Navbar.css";
// import { Link, useLocation } from "react-router-dom";

// const Navbar = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [isGalleryView, setIsGalleryView] = useState(false);
//   const location = useLocation();

//   const toggleMenu = () => setIsOpen((prev) => !prev);
//   const closeMenu = () => setIsOpen(false);

//   // ✅ Detect route change and set Gallery mode
//   useEffect(() => {
//     if (location.pathname === "/gallery") {
//       setIsGalleryView(true);
//     } else {
//       setIsGalleryView(false);
//     }
//     setIsOpen(false); // close menu automatically on route change
//   }, [location.pathname]);

//   return (
//     <header className={`navbar ${isGalleryView ? "gallery-active" : ""}`}>
//       <div className="navbar-inner">
//         {/* Logo + Company Name */}
//         <div className="compony-logo-and-name">
//           <a href="/" className="navbar-brand" onClick={closeMenu}>
//             <img src={logo} alt="VentureBiz Logo" />
//           </a>
//           <h3 className="companyName">Venturebiz Promotions Pvt Ltd.</h3>
//         </div>

//         {/* Navigation Menu */}
//         {!isGalleryView && (
//           <nav className={`nav-menu ${isOpen ? "open" : ""}`}>
//             <ul>
//               <li><a href="#about" onClick={closeMenu}>About Us</a></li>
//               <li><a href="#blog" onClick={closeMenu}>Blog</a></li>
//               <li><a href="#products" onClick={closeMenu}>Our Products</a></li>
//               <li><a href="#services" onClick={closeMenu}>Our Services</a></li>
//               <li><a href="#why-us" onClick={closeMenu}>Why Us</a></li>
//               <li><Link to="/gallery" onClick={closeMenu}>Visuals</Link></li>
//               <li><Link to="/recognitions" onClick={closeMenu}>Recognitions</Link></li>            
//             </ul>
//           </nav>
//         )}

//         {/* Contact + Hamburger */}
//         {!isGalleryView && (
//           <div className="navbar-actions">
//             <a href="#contact" className="btn-cta">Contact Us</a>
//             <button
//               className={`hamburger ${isOpen ? "is-active" : ""}`}
//               onClick={toggleMenu}
//               aria-label="Toggle Menu"
//             >
//               <span />
//               <span />
//               <span />
//             </button>
//           </div>
//         )}
//       </div>
//     </header>
//   );
// };

// export default Navbar;

// src/components/Navbar.js
import React, { useState, useEffect } from "react";
import logo from "../assets/logo_VBZ.png";
import "../styles/Navbar.css";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isGalleryView, setIsGalleryView] = useState(false);
  const location = useLocation();

  const toggleMenu = () => setIsOpen((prev) => !prev);
  const closeMenu = () => setIsOpen(false);

  useEffect(() => {
    const fullScreenRoutes = ["/gallery", "/recognitions"];

    if (fullScreenRoutes.includes(location.pathname)) {
      setIsGalleryView(true);
    } else {
      setIsGalleryView(false);
    }

    setIsOpen(false);
  }, [location.pathname]);

  return (
    <header className={`navbar ${isGalleryView ? "gallery-active" : ""}`}>
      <div className="navbar-inner">
        
        {/* Logo + Company Name */}
        <div className="compony-logo-and-name">
          <Link to="/" className="navbar-brand" onClick={closeMenu}>
            <img src={logo} alt="VentureBiz Logo" />
          </Link>
          <h3 className="companyName">Venturebiz Promotions Pvt Ltd.</h3>
        </div>

        {/* Hide full menu for Gallery & Recognitions */}
        {!isGalleryView && (
          <>
            <nav className={`nav-menu ${isOpen ? "open" : ""}`}>
              <ul>
                <li><a href="#about" onClick={closeMenu}>About Us</a></li>
                <li><a href="#blog" onClick={closeMenu}>Blog</a></li>
                <li><a href="#products" onClick={closeMenu}>Our Products</a></li>
                <li><a href="#services" onClick={closeMenu}>Our Services</a></li>
                <li><a href="#why-us" onClick={closeMenu}>Why Us</a></li>
                <li><Link to="/gallery" onClick={closeMenu}>Visuals</Link></li>
                <li><Link to="/recognitions" onClick={closeMenu}>Recognitions</Link></li>
              </ul>
            </nav>

            <div className="navbar-actions">
              <a href="#contact" className="btn-cta">Contact Us</a>
              <button
                className={`hamburger ${isOpen ? "is-active" : ""}`}
                onClick={toggleMenu}
                aria-label="Toggle Menu"
              >
                <span />
                <span />
                <span />
              </button>
            </div>
          </>
        )}
      </div>
    </header>
  );
};

export default Navbar;
